import Login from './login'
import Default from './default'

import AnalisiCommessa from './report/analisi-commessa'
import AnalisiCommesseAperte from './report/analisi-commesse-aperte'
import Argomenti from './argomenti'
import Avanzamenti, { createAvanzamenti } from './avanzamenti'
import Casi, { createCasi } from './casi'
import Clienti from './clienti'
import ConsuntiviPerContratto from './report/consuntivi-per-contratto'
import Contratti from './contratti'
import DettaglioConsuntivi from './report/dettaglio-consuntivi'
import Fornitori from './fornitori'
import Incassi from './incassi'
import InterrogazioneConsuntivi from './report/interrogazione-consuntivi'
import Ordini from './ordini'
import Parametri from './parametri'
import RegolaritaConsuntivi from './report/regolarita-consuntivi'
import Ruoli from './ruoli'
import StatoOdl from './report/stato-odl'
import Tabelle from './tabelle'
import TicketsOrdini from './tickets-ordini'
import TipologieDocumento from './tipologie-documento'
import Utenti from './utenti'

export default {
    'login': Login,
    'default': Default,
    'analisi-commessa': AnalisiCommessa,
    'analisi-commesse-aperte': AnalisiCommesseAperte,
    'argomenti': Argomenti,
    'avanzamenti': Avanzamenti,
    'casi': Casi,
    'clienti': Clienti,
    'consuntivi-per-contratto': ConsuntiviPerContratto,
    'contratti': Contratti,
    'costi-interni-avanzamenti': createAvanzamenti({ filterPath: '/costi-interni-avanzamento-casi' }),
    'costi-interni-casi': createCasi({ filterPath: '/costi-interni-casi' }),
    'dettaglio-consuntivi': DettaglioConsuntivi,
    'fornitori': Fornitori,
    'incassi': Incassi,
    'interrogazione-consuntivi': InterrogazioneConsuntivi,
    'ordini': Ordini,
    'parametri': Parametri,
    'regolarita-consuntivi': RegolaritaConsuntivi,
    'ruoli': Ruoli,
    'stato-odl': StatoOdl,
    'tabelle': Tabelle,
    'tickets-ordini': TicketsOrdini,
    'tipologie-documento': TipologieDocumento,
    'utenti': Utenti
}

export const InitialPages = [
    Login,
    Default
]
